import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {CourseCommentsComponent} from './course-comments.component';
import {FormsModule} from '@angular/forms';
import {ProfileImageModule} from '../../pipes';
import {TranslateModule} from '@ngx-translate/core';

@NgModule({
  declarations: [CourseCommentsComponent],
  exports: [
    CourseCommentsComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ProfileImageModule,
    TranslateModule
  ]
})
export class CourseCommentsModule {
}
